import { Stack } from '@mui/material'

import { form } from '../../../formState'

import { createValidateServiceTime } from './hooks/createValidateServiceTime'
import { useTexts } from './hooks/useTexts'

const options = [
  '00:01',
  '00:05',
  '00:10',
  '00:15',
  '00:30',
  '00:45',
  '01:00',
  '01:30',
  '02:00',
  '04:00',
]

export function ServiceTime() {
  const texts = useTexts()

  form.useAddFieldValidation('serviceTimeSec', (field, _formApi) => {
    const validationServiceTime = createValidateServiceTime(texts, field.value)

    return (
      validationServiceTime?.hasValidFormatError?.message ||
      validationServiceTime?.exceededMaxCountError?.message
    )
  })

  return (
    <Stack width="50%">
      <form.BulkAutocomplete
        name="serviceTimeSec"
        mixedLabel={texts.mixed}
        label={texts.serviceTime}
        options={options}
        validateOn="change"
        testId="serviceTimeSec"
      />
    </Stack>
  )
}
